module.exports = __webpack_public_path__ + "static/media/img_ai_05.703bc0d8.png";